import {
  decryptObject,
  decryptStringTID,
  encryptObject,
  encryptStringTID,
} from "./crypto";

/* ======= Tab ID (per-tab session identifier used as encryption key) ======= */

export const setTabID = () => {
  try {
    if (!sessionStorage.getItem("t_3b_1d_1")) {
      const uniqueID = encryptStringTID(Date.now().toString());
      sessionStorage.setItem("t_3b_1d_1", uniqueID);
    }
  } catch (error) {
    console.error("An error occurred while setting the tab ID:", error);
  }
};

export const getTabID = () => {
  try {
    const tabId = sessionStorage.getItem("t_3b_1d_1");
    return decryptStringTID(tabId);
  } catch (error) {
    console.error("An error occurred while getting the tab ID:", error);
  }
};

/* ======= Access Token ======= */

export const setToken = (token) => {
  if (token) {
    try {
      sessionStorage.setItem(`t${getTabID()}knInfo`, encryptObject(token));
    } catch (error) {
      console.error("An error occurred while setting tknInfo:", error);
    }
  } else {
    sessionStorage.removeItem("t_O_k_E_n");
    sessionStorage.setItem("t_O_k_E_n", JSON.stringify(null));
  }
};

export const getToken = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`t${getTabID()}knInfo`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting tknInfo:", error);
  }
};

/* ======= Refresh Token ======= */

export const setRefreshToken = (token) => {
  if (token) {
    try {
      sessionStorage.setItem(`rf_t${getTabID()}knInfo`, encryptObject(token));
    } catch (error) {
      console.error("An error occurred while setting rf_tknInfo:", error);
    }
  } else {
    sessionStorage.removeItem("rf_t_O_k_E_n");
    sessionStorage.setItem("rf_t_O_k_E_n", JSON.stringify(null));
  }
};

export const getRefreshToken = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`rf_t${getTabID()}knInfo`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting rf_tknInfo:", error);
  }
};

/* ======= Login Info (user profile + roles) ======= */

export const setLoginInfo = (LoginData) => {
  try {
    if (LoginData) {
      sessionStorage.setItem(
        `u_Se_${getTabID()}r_In_fo`,
        encryptObject(LoginData),
      );
    } else {
      sessionStorage.setItem(`u_Se_${getTabID()}r_In_fo`, encryptObject(null));
    }
  } catch (error) {
    console.error("An error occurred while setting userInfo:", error);
  }
};

export const getLoginInfo = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`u_Se_${getTabID()}r_In_fo`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting userInfo:", error);
  }
};

/* ======= Search Info (current application search context) ======= */

export const setSearchInfo = (data) => {
  try {
    if (data) {
      sessionStorage.setItem(
        `xsxexaxrxcxh${getTabID()}xsxexaxrxcxh`,
        encryptObject(data),
      );
    } else {
      sessionStorage.setItem(
        `xsxexaxrxcxh${getTabID()}xsxexaxrxcxh`,
        encryptObject(null),
      );
    }
  } catch (error) {
    console.error("An error occurred while setting searchInfo:", error);
  }
};

export const getSearchInfo = () => {
  try {
    return decryptObject(
      sessionStorage.getItem(`xsxexaxrxcxh${getTabID()}xsxexaxrxcxh`) || "{}",
    );
  } catch (error) {
    console.error("An error occurred while getting searchInfo:", error);
  }
};
